import axios from 'axios'

class ExotelService {
  constructor() {
    // Hardcoded values for testing
    this.apiKey = '4e1438c6a471346500cffd3dffde3bdc13b131fbe90e1ebe'
    this.accessToken = '92cb50fd49cf64fe1ffa1ef63b2fb8c89ceb662973735ebf'
    this.subdomain = 'api.exotel.com'
    this.accountSid = 'sattvahuman2'
    
    // Build the base URL
    this.baseURL = `https://${this.apiKey}:${this.accessToken}@${this.subdomain}/v1/Accounts/${this.accountSid}`
    
    console.log('Exotel Service initialized with hardcoded values:', {
      apiKey: '***' + this.apiKey.slice(-4),
      accessToken: '***' + this.accessToken.slice(-4),
      subdomain: this.subdomain,
      accountSid: this.accountSid,
      baseURL: '***' + this.baseURL.slice(-20)
    })
  }

  /**
   * Make an outgoing call to connect two numbers
   * @param {Object} callData - Call parameters
   * @param {string} callData.from - The phone number that will be called first
   * @param {string} callData.to - Your customer's phone number
   * @param {string} callData.callerId - Your ExoPhone/Exotel Virtual Number
   * @param {Object} callData.options - Optional parameters
   * @returns {Promise} - API response
   */
  async makeOutgoingCall(callData) {
    try {
      const { from, to, callerId, options = {} } = callData
      
      // Validate required parameters
      if (!from || !to || !callerId) {
        throw new Error('Missing required parameters: from, to, and callerId are required')
      }

      // Prepare form data
      const formData = new FormData()
      formData.append('From', from)
      formData.append('To', to)
      formData.append('CallerId', callerId)

      // Add optional parameters
      if (options.callType) formData.append('CallType', options.callType)
      if (options.timeLimit) formData.append('TimeLimit', options.timeLimit)
      if (options.timeOut) formData.append('TimeOut', options.timeOut)
      if (options.waitUrl) formData.append('WaitUrl', options.waitUrl)
      if (options.record !== undefined) formData.append('Record', options.record)
      if (options.recordingChannels) formData.append('RecordingChannels', options.recordingChannels)
      if (options.recordingFormat) formData.append('RecordingFormat', options.recordingFormat)
      if (options.customField) formData.append('CustomField', options.customField)
      if (options.startPlaybackToNew) formData.append('StartPlaybackToNew', options.startPlaybackToNew)
      if (options.startPlaybackValueNew) formData.append('StartPlaybackValueNew', options.startPlaybackValueNew)
      if (options.statusCallback) formData.append('StatusCallback', options.statusCallback)
      if (options.statusCallbackEvents) {
        options.statusCallbackEvents.forEach((event, index) => {
          formData.append(`StatusCallbackEvents[${index}]`, event)
        })
      }
      if (options.statusCallbackContentType) formData.append('StatusCallbackContentType', options.statusCallbackContentType)

      // Make the API call
      const response = await axios.post(
        `${this.baseURL}/Calls/connect.json`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      return response.data
    } catch (error) {
      console.error('Exotel API Error:', error)
      throw error
    }
  }

  /**
   * Get call details by CallSid
   * @param {string} callSid - The unique identifier of the call
   * @param {Object} options - Optional parameters
   * @returns {Promise} - API response
   */
  async getCallDetails(callSid, options = {}) {
    try {
      let url = `${this.baseURL}/Calls/${callSid}.json`
      
      // Add optional query parameters
      const params = new URLSearchParams()
      if (options.details) params.append('details', 'true')
      if (options.recordingUrlValidity) params.append('RecordingUrlValidity', options.recordingUrlValidity)
      
      if (params.toString()) {
        url += `?${params.toString()}`
      }

      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error('Exotel Get Call Details Error:', error)
      throw error
    }
  }

  /**
   * Get bulk call details with filters
   * @param {Object} filters - Filter parameters
   * @returns {Promise} - API response
   */
  async getBulkCallDetails(filters = {}) {
    try {
      const params = new URLSearchParams()
      
      // Add filter parameters
      Object.keys(filters).forEach(key => {
        if (filters[key] !== undefined && filters[key] !== null) {
          params.append(key, filters[key])
        }
      })

      const url = `${this.baseURL}/Calls.json${params.toString() ? `?${params.toString()}` : ''}`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error('Exotel Bulk Call Details Error:', error)
      throw error
    }
  }

  /**
   * Get number metadata
   * @param {string} phoneNumber - The phone number to get metadata for
   * @returns {Promise} - API response
   */
  async getNumberMetadata(phoneNumber) {
    try {
      const response = await axios.get(`${this.baseURL}/Numbers/${phoneNumber}.json`)
      return response.data
    } catch (error) {
      console.error('Exotel Number Metadata Error:', error)
      throw error
    }
  }
}

export default new ExotelService()
